import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { TDiscountItemTableRow } from './types';

export const discountItemTableStructure: TTableStructure<
	keyof TDiscountItemTableRow,
	TDiscountItemTableRow
>[] = [
	{
		selector: 'id_provided_by_em',
		name: 'Item ID',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'short_description',
		name: 'Product Name',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
		colSpan: 2,
	},
	{
		selector: 'rep_scheme',
		name: 'Representation Scheme',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'report_type',
		name: 'Report Type',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'quantity',
		name: 'Quantity',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		selector: 'discount_amount',
		name: 'Discount Amount',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item) => item.payment_currency_code ?? 'EUR',
	},
	{
		selector: 'total_discountable_amount',
		name: 'Total Discountable Amount',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item) => item.payment_currency_code ?? 'EUR',
	},
	{
		selector: 'discount_on_cost',
		name: 'Discount on Cost',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item) => item.payment_currency_code ?? 'EUR',
	},
	{
		selector: 'discount_on_vat',
		name: 'Discount on VAT',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item) => item.payment_currency_code ?? 'EUR',
	},
];
